import { ShieldCheck, BadgeCheck, Building2, Medal, Scale, Lock, Globe } from "lucide-react";
import { TRUST_SIGNALS } from "../../data/site";

const ICONS = { ShieldCheck, BadgeCheck, Building2, Medal, Scale, Lock, Globe };

export default function TrustSignals() {
  return (
    <section data-testid="trust-signals" className="relative border-y border-border bg-secondary/60">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex items-center justify-between gap-4 border-b border-border/60 py-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
            Institutional Credentials &amp; Registrations
          </span>
          <div className="hidden items-center gap-5 font-mono text-[9px] uppercase tracking-[0.2em] text-muted-foreground sm:flex">
            <span className="flex items-center gap-2"><span className="trust-dot-active h-1.5 w-1.5 rounded-full" /> Active</span>
            <span className="flex items-center gap-2"><span className="trust-dot-pending h-1.5 w-1.5 rounded-full" /> In&nbsp;Progress</span>
          </div>
        </div>
        <ul className="grid grid-cols-1 divide-y divide-border/60 border-b border-border/60 sm:grid-cols-2 sm:divide-x lg:grid-cols-4">
          {TRUST_SIGNALS.map((t) => {
            const Icon = ICONS[t.icon] || ShieldCheck;
            const active = t.status === "active";
            return (
              <li
                key={t.label}
                data-testid={`trust-${t.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className="group flex flex-col gap-3 px-5 py-6 transition-colors hover:bg-white"
              >
                <div className="flex items-center justify-between">
                  <Icon size={18} className={active ? "text-foreground" : "text-muted-foreground"} strokeWidth={1.5} />
                  <span
                    className={`h-1.5 w-1.5 rounded-full ${active ? "trust-dot-active" : "trust-dot-pending"}`}
                    aria-label={active ? "Active" : "In progress"}
                  />
                </div>
                <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-foreground/90">
                  {t.label}
                </span>
                <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-muted-foreground">
                  {t.statusLabel || (active ? "Active" : "In Progress")}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
